import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Code } from "@modules/codes/types";
import { CodeFormValues } from "@modules/codes/validations";

import { createCodeService } from "./service";
import { UseCreateCodeMutationOptions } from "./types";

export function useCreateCodeMutation(
  options?: UseCreateCodeMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Code, ApiError, CodeFormValues>({
    mutationFn: createCodeService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
